import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormModel} from '../../../../common/components/form/models';
import {MatSelectChange} from '@angular/material/select';
import {FieldsResponseModel} from './fields-response.model';
import {FilterFieldResponseEnabled} from '../../../../common/services/responses/filter-field-response-enabled.model';
import {ResponsesService} from '../../../../common/services/responses/responses.service';
import {SubSink} from '@Common/core/utils/subsink';
import {ResponseStateGestModel} from '../../../../common/components/form/response-states/response-state-gest-model';
import {UtilsService} from '@Services/core/utils/utils.service';


@Component({
  selector: 'app-filter-fields-response-selection',
  templateUrl: './filter-fields-response-selection.component.html',
  styleUrls: ['./filter-fields-response-selection.component.scss']
})
export class FilterFieldsResponseSelectionComponent implements OnInit, OnChanges {
  @Input() form: FormModel;
  @Input() backFilterStates = null;
  @Output() onFiltering: EventEmitter<FilterFieldResponseEnabled[]> = new EventEmitter<FilterFieldResponseEnabled[]>();
  fieldsEnabled: FilterFieldResponseEnabled[] = [];
  selectedField: FieldsResponseModel = null;
  selectedValue: FilterFieldResponseEnabled = null;
  fields: FieldsResponseModel[] = [
    { label: 'Instruction', placeHolder: 'Choisir une instruction', value: '', field: 'by_instructions__state'},
    { label: 'Envoyé le', placeHolder: 'Choisir la date d\'envoi', value: '', field: 'dt_created'},
    { label: 'Modifié le', placeHolder: 'Choisir la date de modification', value: '', field: 'dt_updated'}
  ];
  subSink = new SubSink();
  selectFieldEvent: MatSelectChange;

  constructor(private responsesService: ResponsesService) { }

  ngOnInit(): void {
    this._listenFilterRaz();
    this._updateBackfilter();
  }

  onSelectField(item: MatSelectChange) {
    this.selectFieldEvent = item;
    this.selectedField = item.value as FieldsResponseModel;
  }
  onValueChanged(option: FilterFieldResponseEnabled) {
    this.selectedValue = option;
  }
  onFilterRaz(filter: FilterFieldResponseEnabled) {
    if (filter) {
      this.responsesService.filterResponseRazSubject.next(filter);
    } else {
      this.responsesService.filterResponseRazAllSubject.next(null);
    }
  }
  isDisabled() {
    return !this.selectedField || !this.selectedValue;
  }
  onAddFilter() {
    this.fieldsEnabled = [...this.fieldsEnabled, ...[this.selectedValue]];
    this.onFiltering.emit(this.fieldsEnabled);
    this.selectedField = null;
    this.selectedValue = null;
    this.selectFieldEvent?.source.writeValue(null);
  }
  isExpanded() {
    return this.backFilterStates !== null;
  }
  private _listenFilterRaz() {
    this.subSink.sink = this.responsesService.onFilterResponseRaz$
      .subscribe((_filter: FilterFieldResponseEnabled) => {
        this._dropFilterInEnabled(_filter);
        this.onFiltering.emit(this.fieldsEnabled);
      });
    this.subSink.sink = this.responsesService.onFilterResponseRazAll$.subscribe(_ => {
      this.fieldsEnabled = [];
      this.onFiltering.emit(this.fieldsEnabled);
    });
  }
  private _dropFilterInEnabled(filter) {
    const idx = this.fieldsEnabled.indexOf(filter);
    if (idx !== -1) {
      this.fieldsEnabled.splice(idx, 1);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
  }
  private _setResponseStateGestModelBackfilter(state: number): ResponseStateGestModel {
    return state === -1 ? this.responsesService.stateStateGestModelWaiting() : this.responsesService.stateResponseInstructionModel(state);
  }
  private _updateBackfilter() {
    if (this.backFilterStates !== null) {
      this.selectedValue = <FilterFieldResponseEnabled>{
        label: 'Instruction',
        type: 'by_instructions__state',
        value: this.backFilterStates.map(v => this._setResponseStateGestModelBackfilter(v))
      };
      this.onAddFilter();
    }
  }
}
